import { IconButton } from '@/components/ui/icon-button'
import * as Table from '@/components/ui/table'
import { EllipsisVertical } from 'lucide-solid'
import { For } from 'solid-js'
import { useService } from 'solid-services'
import { useState } from './state'

export default function () {
  const { scheduledEventNotifications } = useService(useState)()

  return (
    <Table.Root variant="surface" stickyHeader>
      <Table.Head>
        <Table.Row>
          <Table.Header>Job Name</Table.Header>
          <Table.Header>Type</Table.Header>
          <Table.Header>Next Run</Table.Header>
        </Table.Row>
      </Table.Head>
      <Table.Body>
        <For each={scheduledEventNotifications.data?.jobs}>
          {(job) => (
            <Table.Row>
              <Table.Cell>{job.jobName}</Table.Cell>
              <Table.Cell>{job.type}</Table.Cell>
              <Table.Cell>{job.nextRun}</Table.Cell>
            </Table.Row>
          )}
        </For>
      </Table.Body>
    </Table.Root>
  )
}
